import React from 'react';
import { File, FileText, FileImage, Video } from 'lucide-react';

export const getFileTypeIcon = (filename: string, mimeType?: string): React.ReactNode => {
    if (!filename) {
        return <File size={18} />;
    }

    const extension = filename.split('.').pop()?.toLowerCase() || '';
    
    // Check MIME type first if available
    if (mimeType) {
        if (mimeType.startsWith('image/')) {
            return <FileImage size={18} style={{ color: '#16A34A' }} />;
        }
        if (mimeType.startsWith('video/')) {
            return <Video size={18} style={{ color: '#DC2626' }} />;
        }
        if (mimeType === 'application/pdf') {
            return <FileText size={18} style={{ color: '#DC2626' }} />;
        }
        if (mimeType.includes('spreadsheet') || mimeType.includes('excel') || mimeType.includes('csv')) {
            return <FileText size={18} style={{ color: '#16A34A' }} />;
        }
        if (mimeType.includes('word') || mimeType.includes('document')) {
            return <FileText size={18} style={{ color: '#2563EB' }} />;
        }
        if (mimeType.includes('text') || mimeType.includes('code')) {
            return <FileText size={18} style={{ color: '#9333EA' }} />;
        }
    }

    // Fallback to extension-based detection
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v'];
    const documentExtensions = ['doc', 'docx', 'odt', 'rtf'];
    const spreadsheetExtensions = ['xls', 'xlsx', 'csv', 'ods'];
    const codeExtensions = ['js', 'ts', 'jsx', 'tsx', 'py', 'java', 'cpp', 'c', 'html', 'css', 'json', 'xml'];

    if (imageExtensions.includes(extension)) {
        return <FileImage size={18} style={{ color: '#16A34A' }} />;
    }
    if (videoExtensions.includes(extension)) {
        return <Video size={18} style={{ color: '#DC2626' }} />;
    }
    if (extension === 'pdf') {
        return <FileText size={18} style={{ color: '#DC2626' }} />;
    }
    if (spreadsheetExtensions.includes(extension)) {
        return <FileText size={18} style={{ color: '#16A34A' }} />;
    }
    if (documentExtensions.includes(extension)) {
        return <FileText size={18} style={{ color: '#2563EB' }} />;
    }
    if (codeExtensions.includes(extension)) {
        return <FileText size={18} style={{ color: '#9333EA' }} />;
    }

    // Default file icon
    return <File size={18} style={{ color: '#6B7280' }} />;
};

